// extracted by mini-css-extract-plugin
module.exports = {"sideCTABtn":"sideCTABtn_sideCTABtn__15P26"};